import arrow from "../../images/arrow.svg"

export default function CRMCheckOut() {
  return (
    <>
      <section className="px-5 2xl:px-0 py-10 lg:py-20 xl:max-w-6xl xl:mx-auto">
        <h2 className="text-center text-3xl lg:text-5xl mb-5 lg:mb-10">
          Check out what our CRM has to offer to you and your clients.
        </h2>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:place-items-center">
          <ul>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Compliance
            </li>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Report Center
            </li>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              In-house Support Team
            </li>
            <li className="flex mt-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Live Trading Data
            </li>
          </ul>

          <ul>
            <li className="flex md:mt-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Algo Trading API
            </li>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Social Trading API
            </li>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Client Area
            </li>
            <li className="flex my-5 md:my-8 font-bold text-xl lg:text-2xl">
              <img src={arrow} alt="Arrow" title="Arrow" className="mr-5 w-8" />
              Anti-Fraud Management
            </li>
          </ul>
        </div>
      </section>
    </>
  )
}
